import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeImg from "../../Assets/home_img.png";
import underIcon from "../../Assets/under_icon.png";
import Home2 from "./Home2";

import Typewriter from "typewriter-effect";
function Home() {
  const [showUnderIcon, setShowUnderIcon] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const scrollThreshold = windowHeight * 0.3; // 화면 높이의 50%

      if (scrollPosition > scrollThreshold) {
        setShowUnderIcon(false);
      } else {
        setShowUnderIcon(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row className="align-items-center" style={{ minHeight: "80vh" }}>
            <Col md={6} className="home-text-section">
              <div className="home-header">
                <h1 className="home-title">동진에어텍</h1>
                <h2 className="home-subtitle">
                  {/* 믿을 수 있는 냉난방 유지보수 파트너 */}
                  <Typewriter
                    onInit={(typewriter) => {
                      typewriter
                        .pauseFor(1300)
                        .typeString("믿을 수 있는 HVAC 메인터넌스 파트너")
                        .callFunction(() => {
                          // 타이핑 완료 후 커서 숨기기
                          document.querySelector(
                            ".Typewriter__cursor"
                          ).style.display = "none";
                        })
                        .start();
                    }}
                    options={{
                      delay: 75,
                      cursor: "|",
                    }}
                  />
                </h2>
                <p className="home-description">
                  산업현장의 쾌적한 환경을 위해{" "}
                  <br className="tablet-line-break" />
                  24시간 긴급 대응 / 정기점검 / 최적 솔루션 제공
                </p>
              </div>
            </Col>
            <Col md={6} className="home-image-section">
              <div className="home-image-container">
                <img
                  src={homeImg}
                  alt="동진에어텍 홈 이미지"
                  className="home-main-image"
                />
              </div>
            </Col>
          </Row>
          {/* Under icon at the bottom center of first page */}
          <div
            className={`under-icon-container ${
              showUnderIcon ? "visible" : "hidden"
            }`}
          >
            <img src={underIcon} alt="하단 아이콘" className="under-icon" />
          </div>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
